import * as ko from 'knockout';
import * as moment from 'moment';

// Configuration
import { JoinConfiguration } from 'Content/ts/Models/Join/JoinConfiguration';

// Models
import { INewMemberContactDetailsModel } from 'Content/ts/Models/Join/Interfaces/INewMemberContactDetailsModel';
import { IMembershipBasketRequestModel } from 'Content/ts/Models/Join/Interfaces/IMembershipBasketRequestModel';
import { IMandateDetails } from 'Content/ts/Models/Join/Interfaces/IMandateDetails';
import { IMarketingPreferences } from 'Content/ts/Models/Join/Interfaces/IMarketingPreferences';
import { AddressType } from 'Content/ts/Models/Shared/Enums/addressTypes';
import { IAddressModel } from './Interfaces/IAddressModel';
import { ContactServiceReserveRequestModel } from 'Content/ts/Models/Membership/ContactServices/ContactServiceReserveRequestModel';
import { MembershipType } from 'Content/ts/Models/Join/MembershipType';
import { FeeProcessType } from 'Content/ts/Models/Membership/BankDetails/PrimaryAccountCreationRequestModel';

// Services
import { DateTimeFormatterService } from "Content/ts/Shared/Controls/DateTime/Services/dateTimeFormatterService";

export class JoinMemberBaseRequestModel {
    BasketItem: IMembershipBasketRequestModel;
    MemberServiceBasketItem: ContactServiceReserveRequestModel;
    MandateDetails: IMandateDetails;
    MarketingPreferences: IMarketingPreferences;
    MembershipType: MembershipType;

    constructor(config: JoinConfiguration) {
        var clubId = config.facilityId;
        var mandateDetails = config.mandateDetails;
        var marketingPreferences = config.marketingPreferences;

        let accountNumber, sortCode = '';

        switch (mandateDetails.FeeProcessType()) {
            case FeeProcessType.DirectDebit: {
                accountNumber = mandateDetails.AccountNumber();
                sortCode = mandateDetails.SortCode();
                break;
            }
            case FeeProcessType.SEPA: {
                accountNumber = mandateDetails.Iban();
                sortCode = mandateDetails.Bic();
                break;
            }
            case FeeProcessType.CPA: {
                accountNumber = mandateDetails.CanadaAccountNumber();
                sortCode = mandateDetails.CanadaSortCode();
                break;
            }
            case FeeProcessType.PNZ: {
                accountNumber = mandateDetails.GenericAccountNumber();
                sortCode = mandateDetails.GenericSortCode();
                break;
            }
            case FeeProcessType.CreditCard: {
                break;
            }
        }

        this.MandateDetails = accountNumber ? {
            AccountNumber: accountNumber,
            SortCode: sortCode,
            AccountName: mandateDetails.AccountName(),
            FeeProcessType: mandateDetails.FeeProcessType()
        } : null;   // only set if billing type is DD

        this.MarketingPreferences = {
            Email: marketingPreferences.Email()
        }

        if (config.membershipType() == MembershipType.Agreement) {
            this.BasketItem = {
                ClubId: clubId(),
                AgreementPriceId: config.selectedMembershipPrice().Id,
                BillingMethodId: config.priceDetails.BillingMethodId(),
                PriceRequestGroupId: config.priceDetails.PriceRequestGroupId(),
                StartDate: config.membershipStartDateString(),
                BasketId: null,
                MCD: config.priceDetails.MCD(),
                OverrideNewMembershipDescription: null,
                OverrideEnrollmentFeeDescription: null,
                OverrideProrateFeeDescription: null,
                OverrideFirstMonthFeeDescription: null,
                OverridePIFFeeDescription: null,
                OverrideAdminFeeDescription: null,
                OverrideMonthInHandFeeDescription: null,
                PromoCode: config.promoCode()
            };
        }
        else {
            this.MemberServiceBasketItem = {
                ServiceId: config.selectedMembershipPrice().MembershipId,
                ServiceOptionId: config.selectedMembershipPrice().Id,
                ServiceOptionFriendlyName: config.selectedMembershipPrice().Name,
                ClubId: clubId(),
                StartDate: config.membershipStartDateString(),
                BillingCycleId: config.selectedMembershipPrice().BillingCycleId,
                BillingMethod: config.selectedMembershipPrice().BillingMethodId,
                ContactFundingId: null,
                ContactId: null
            };
        }

        this.MembershipType = config.membershipType();

        delete (<any>this).constructor;
        delete (<any>this).__proto__.constructor;
    }

}

export class JoinMemberRequestModel extends JoinMemberBaseRequestModel {
    Contact: INewMemberContactDetailsModel;
    
    constructor(config: JoinConfiguration) {
        super(config);
        const contactDetails = config.contactDetails;

        const homeAddress = contactDetails.getAddressDetailsForType(AddressType.Home);
        const addresses = [{
            Address1: homeAddress.AddressLine1(),
            Address2: homeAddress.AddressLine2(),
            City: homeAddress.City(),
            Region: homeAddress.County(),
            Country: homeAddress.Country(),
            PostCode: homeAddress.Postcode(),
            Phone: homeAddress.Phone(),
            EmergencyName: contactDetails.EmergencyName(),
            EmergencyNumber: contactDetails.EmergencyPhone(),
            EmergencyName2: contactDetails.EmergencyTwoName(),
            EmergencyNumber2: contactDetails.EmergencyTwoPhone(),
            enumAddressTypeID: homeAddress.AddressTypeId
        }] as IAddressModel[];

        this.Contact = {
            FirstName: contactDetails.FirstName(),
            LastName: contactDetails.LastName(),
            Title: contactDetails.Title(),
            DateOfBirth: contactDetails.DateOfBirth() !== undefined ? contactDetails.DateOfBirth().format(DateTimeFormatterService.TimeZoneAgnosticAjaxFormat) : null,
            Email: contactDetails.EmailAddress(),
            ClubId: config.facilityId(),
            GenderId: contactDetails.GenderId(),
            EmployerName: contactDetails.Employer(),
            EthnicOriginId: contactDetails.EthnicOriginId(),
            Occupation: contactDetails.Occupation(),
            MarketingSourceId: contactDetails.MarketingSourceId(),
            ReferringMember: contactDetails.ReferringMember(),
            Addresses: addresses
        };
    }
}